import React from "react";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function PromoterRow({ promoter, rank, select }) {
  // Apply transformation to constrain image to max 45px width
  const max45pxProfileImageUrl = promoter.profile_image_url.replace(
    /upload\/v\d+\//,
    "upload/w_45,q_auto,f_auto,c_scale/",
  );

  return (
    <tr>
      <td>{rank}</td>
      <td>
        <div className="d-flex flex-row">
          <ImageCropped
            roundedCircle
            wrapperClasses="me-2"
            src={max45pxProfileImageUrl}
            alt={promoter.profile_name}
            size={45}
          />
          <div>
            <button type="button" className="btn btn-link p-0" onClick={() => select()}>
              {promoter.profile_name}
            </button>
          </div>
        </div>
      </td>
      <td>{promoter.email}</td>
      <td>
        <a href={`/companies/${promoter.company_slug}`}>{promoter.company_name}</a>
      </td>
      <td>{promoter.v1_user_id}</td>
      <td>
        {globalThis.Qwoted.V1_URL && (
          <a href={`${globalThis.Qwoted.V1_URL}/users/${promoter.v1_user_id}`}>V1 User Link</a>
        )}
      </td>
      <td>Speed points: {promoter.pitch_speed_points || 0}</td>
      <td>Outcome points: {promoter.conversation_outcome_points + promoter.direct_media_reply_points}</td>
      <td>{promoter.bad_behavior_points}</td>
      <td>{promoter.total_points}</td>
    </tr>
  );
}

export default PromoterRow;
